/*
 * Copyright (c) Nexign, JSC, 2019-2021.
 */
/**
 *
 * @author Yakov Gushchin
 * @version 1.15.0
 * @since 1.0.0
 */
import ICommonTranslationCalendar from '../../types/common/calendar';

const initTranslationCalendar: ICommonTranslationCalendar = {
    additionalButtons: {
        deselectDate: '',
    },
    monthsDictionary: {
        January: 'January',
        February: 'February',
        March: 'March',
        April: 'April',
        May: 'May',
        June: 'June',
        July: 'July',
        August: 'August',
        September: 'September',
        October: 'October',
        November: 'November',
        December: 'December',
    },
    months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October',
        'November', 'December'],
    monthDeclension: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October',
        'November', 'December'],
    period: {
        D: '',
        M: '',
        W: '',
    },
    placeholder: '',
    weeks: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
    weekLabel: 'W',
    monthPickerPresets: {
        period: 'Текущий период',
        quarter: 'Квартал',
        startYear: 'С начала года',
    },
    time: {
        timezone: '',
        timepicker: '',
    },
};

export default initTranslationCalendar;
